import {
  TGROUP_START,
  TGROUP_SUCCESS,
  VIRTUALTX_START,
  VIRTUALTX_SUCCESS,
} from "../types/index";

const getTgroupSuccess = (tgroup) => {
  return {
    type: TGROUP_SUCCESS,
    tgroup: tgroup,
  };
};

const getTgroupStart = () => {
  return {
    type: TGROUP_START,
  };
};

const getvirtualTxSuccess = (virtualTx) => {
  return {
    type: VIRTUALTX_SUCCESS,
    virtualTx: virtualTx,
  };
};

const getvirtualTxStart = () => {
  return {
    type: VIRTUALTX_START,
  };
};

export {
  getTgroupSuccess,
  getTgroupStart,
  getvirtualTxSuccess,
  getvirtualTxStart,
};
